import { render } from "./Mild_dizziness.vue?vue&type=template&id=48071ba7"
import script from "./Mild_dizziness.vue?vue&type=script&lang=js"
export * from "./Mild_dizziness.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__